import React, { useState, useEffect, useRef } from 'react'

export default function Flashcard({ flashcard }) {
  const [flip, setFlip] = useState(false)
  const [height, setHeight] = useState('initial')

  // const frontEl = useRef()
  const backEl = useRef()

  function setMaxHeight() {
    // const frontHeight = frontEl.current.getBoundingClientRect().height
    const backHeight = backEl.current.getBoundingClientRect().height
    setHeight(Math.max(backHeight, 300))
  }

  useEffect(setMaxHeight, [flashcard.question, flashcard.answer, flashcard.options])
  useEffect(() => {
    window.addEventListener('resize', setMaxHeight)
    return () => window.removeEventListener('resize', setMaxHeight)
  }, [])

  return (
    <div
      className={`card ${flip ? 'flip' : ''}`}
      style={{ height: height }}
      // onClick={() => setFlip(!flip)}
      onClick={() => window.location.href = flashcard.link}
    >
      {/* <div className="front" ref={frontEl}>
                <div className='logo-container-cards'>
                  <img className='logo' src={require('../../img/logo.png')} alt="alt"/>
                </div>
                <div>
                  {flashcard.question}
                </div>
      </div> */}

      <div className="front" ref={backEl}>{flashcard.answer}

      </div>
      
      <div className="back" ref={backEl}>{flashcard.answer}</div>     
    </div>
  )
}

